import licencePlateTypeConstants from "constants/licencePlateTypes";

export default {
  [licencePlateTypeConstants.CUSTOM]: 6,
  [licencePlateTypeConstants.POLICE]: 7,
  [licencePlateTypeConstants.MILITARY]: 8,
  [licencePlateTypeConstants.DIPLOMATIC_CMD]: 8,
  [licencePlateTypeConstants.DIPLOMATIC_CD]: 7,
  [licencePlateTypeConstants.DIPLOMATIC_M]: 6,
}